import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  Card,
  Chip,
  LabelValueList,
  Skeleton,
  sizeVars,
} from '@routific/hive/v5';

const InlineRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizeVars.space[50]};
`;

const SKELETON_ROWS = [
  { id: 'label-1', labelWidth: 72, valueWidth: '55%' },
  { id: 'label-2', labelWidth: 88, valueWidth: '70%' },
  { id: 'label-3', labelWidth: 64, valueWidth: '40%' },
] as const;

interface Props {
  'data-testid'?: string;
  variant?: 'status' | 'title';
  announce?: boolean;
}

const DetailsCardSkeleton: React.FC<Props> = ({
  'data-testid': testId = 'skeleton-loading',
  variant = 'status',
  announce = true,
}) => {
  const { t } = useTranslation('common');

  const header = variant === 'title' ? (
    <Skeleton width={140} />
  ) : (
    <InlineRow style={{ width: '100%' }}>
      <Chip skeleton size="sm" />
      <Skeleton width={120} style={{ marginLeft: 'auto' }} />
    </InlineRow>
  );

  return (
    <Card
      header={header}
      data-testid={testId}
      role={announce ? 'status' : undefined}
      aria-busy={announce ? true : undefined}
      aria-label={announce ? t('loading.generic') : undefined}
    >
      <LabelValueList
        items={SKELETON_ROWS.map((row) => ({
          id: row.id,
          label: <Skeleton width={row.labelWidth} />,
          value: <Skeleton width={row.valueWidth} />,
        }))}
      />
    </Card>
  );
};

export default DetailsCardSkeleton;
